<div class="contact">
    <section>
        <div class="banner row justify-content-center" [style.background]="backgroundImageURL">
            <h1 class="m-auto">Contact Neprose</h1>
        </div>
    </section>
    <div class="container">
        <div class="page-contents">
            <div class="form-contents">
                <div class="row">
                    <div class="col-md-6 mb-4">
                        <form [formGroup]="contactForm">
                            <input type="text" formControlName="name" placeholder="Full Name *" required><br>
                            <input type="email" formControlName="email" placeholder="Email *" required><br>
                            <textarea rows="5" formControlName="message" placeholder="Enter your message" required></textarea>
                            <button [disabled]="contactForm.invalid" (click)="submitContact()">Send</button>
                        </form>
                    </div>
                    <div class="col-md-6 pt-2 mb-4">
                        <p><strong>Nepal Property Services (NEPROSE)
                        </strong><br> Hanuman Nagar, Birtamod 1, Jhapa, Nepal<br> (behind National Tea and Coffee Development Board)
                        </p>
                        <br>
                        <p>
                            <strong>Tel.</strong> 00977 23546089 || 
                            <strong>Mob.</strong> 00977 9852646089<br> 
                            <img src="assets\whatsapp.png" style="margin-right: 5px;"><strong>WhatsApp and <img src="assets\viber.png" style="margin-right: 5px;">Viber:</strong> 9852646089<br>
                            <strong>Skype:</strong> neprose<br> 
                            <strong>Email:</strong> nepalpropertyservices@gmail.com<br> 
                            <strong>Web:</strong> www.neprose.com
                        </p>
                        <br>
                        <p><strong>Social networks
                        </strong><br>
                            <a href="https://www.facebook.com/nepalpropertyservices"><img src="../../assets/fb.png" style="width: 24px;"></a>
                            <a href="https://plus.google.com/u/0/+NepalPropertyServices"><img src="../../assets/gp.png"></a>
                            <a href="https://twitter.com/neprose"><img src="../../assets/tt.png" style="width: 20px;"></a>
                            <a href="https://www.instagram.com/neprose/"><img src="../../assets/ig.png" style="width: 20px;"></a>
                        </p>
                    </div>
                </div>
            </div>
            <iframe style="margin-top: 60px;" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3566.280938231214!2d87.9814235!3d26.639486!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd3aa841b094beea1!2sNepal%20Property%20Services!5e0!3m2!1sen!2snp!4v1600931544109!5m2!1sen!2snp"
                width="100%" height="350px" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
    </div>
</div>